import BlogCarousel from "@/components/blog/blog-carousel";
import BlogItemAlt from "@/components/blog/blog-item-alt";
import { CustomerTestimonial } from "@/components/mhealth-studio/customer-testimonial/customer-testimonial";
import GetInTouchSection from "@/components/mhealth-studio/get-in-touch/get-in-touch-section";
import MhealthStudioHero from "@/components/mhealth-studio/hero/mhealth-studio-hero";
import HowMhealthStudioWorks from "@/components/mhealth-studio/how-mhealth-studio-works/how-mhealth-studio-works";
import KeyFeatures from "@/components/mhealth-studio/key-features/key-features";
import MhealthBlogs from "@/components/mhealth-studio/mhealth-blogs";
import MoreInfo from "@/components/mhealth-studio/more-info/more-info";
import OnlineDataManagement from "@/components/mhealth-studio/online-data-management/online-data-management";
import MhealthPricing from "@/components/mhealth-studio/pricing/mhealth-pricing";
import Publications from "@/components/mhealth-studio/publications/publications";
import WhatIsMhealth from "@/components/mhealth-studio/what-is-mhealth/what-is-mhealth";
import i18n from "@/i18n/config";
import { blogData } from "@/i18n/json/blog";
import { IPost } from "@/i18n/json/blog/interfaces";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Layout } from "../layouts";

const MhealthStudio: React.FC<{
  filteredBlogData: IPost[] | null;
  enBlog: any;
  esBlog: any;
}> = ({ filteredBlogData, enBlog, esBlog }) => {
  if (filteredBlogData) {
    i18n.changeLanguage("en").then();
    i18n.addResourceBundle("en", "translation", { blog: enBlog }, true, false);
    i18n.addResourceBundle("es", "translation", { blog: esBlog }, true, false);
  }
  return (
    <Layout page={"mhealth"}>
      <MhealthStudioHero />
      <WhatIsMhealth />
      <OnlineDataManagement />
      <CustomerTestimonial />
      <HowMhealthStudioWorks />
      {filteredBlogData && (
        <MhealthBlogs
          component={
            <BlogCarousel
              data={filteredBlogData}
              BlogItemComponent={BlogItemAlt}
            />
          }
        />
      )}
      <MoreInfo />
      <KeyFeatures />
      <GetInTouchSection />
      <MhealthPricing />
      <Publications />
    </Layout>
  );
};

export default MhealthStudio;

const anyPropertyContains = (obj: any, search: string) => {
  return Object.values(obj).reduce((acc, val) => {
    if (
      typeof val === "string" &&
      val.toLowerCase().includes(search.toLowerCase())
    )
      acc = true;
    return acc;
  }, false);
};

export async function getStaticProps() {
  const blogPostData = await blogData();
  const filteredBlogData = blogPostData.data.all
    .filter((blog) => {
      return anyPropertyContains(blog, "mhealth");
    })
    .slice(0, 3);

  const enBlog = blogPostData && blogPostData.en;
  const esBlog = blogPostData && blogPostData.es;

  return {
    props: {
      filteredBlogData,
      enBlog,
      esBlog,
    },
  };
}
